<div class="container-tig">
    <div class="title">
        <h4>蒙古文无衬线报体商用授权</h4>
    </div>
    <div style="margin-top: 60px;">
        <div style="text-align: center;">
            <h4>获取授权流程</h4>
            <p class="title-b"></p>
        </div>
        <div class="sq">
            <div class="sq-lc">
                <img src="/assets/images/sq/01.png" alt="Onon字体 - 图片01">
                <h3>选择授权模式并购买</h3>
            </div>
            <div class="sq-lc">
                <img src="/assets/images/sq/02.png" alt="Onon字体 - 图片02">
                <h3>填写授权信息</h3>
            </div>
            <div class="sq-lc">
                <img src="/assets/images/sq/03.png" alt="Onon字体 - 图片03">
                <h3>下载授权书</h3>
            </div>
        </div>
    </div>
    <div style="margin-top: 60px;">
        <div style="text-align: center;">
            <h4>授权模式</h4>
            <p class="title-b"></p>
        </div>
        <div class="sq-gm ">
            <div class="sq-gm-i ">
                <h3>个人商用授权</h3>
                <p class="hz-lx-text">适用个人主体</p>
                <br>
                <br>
                <div>
                    <strong>XX</strong>元/年
                </div>
                <div class="gm">
                    <span>
                        如需授权
                        <br>
                        请用联系方式联系
                    </span>
                </div>
            </div>
            <div class="sq-gm-i ">
                <h3>企业商用授权</h3>
                <p class="hz-lx-text">适用企业主体</p>
                <br>
                <br>
                <div>
                    <strong>XX</strong>元/年
                </div>
                <div class="gm">
                    <span>
                        如需授权
                        <br>
                        请用联系方式联系
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div style="margin-top: 60px;">
        <div style="text-align: center;">
            <h4>蒙古文无衬线报体授权范围</h4>
            <p class="title-b"></p>
        </div>
        <div>
            <table class="table table-borderless">
                <tr>
                    <th>授权范围</th>
                    <th>适用范围</th>
                    <th>个人商用授权</th>
                    <th>企业商用授权</th>
                </tr>
                <tr>
                    <td>网店设计用途</td>
                    <td>第三方电商平台店铺设计用字</td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>网站设计用途</td>
                    <td>网站设计用字（宣传 banner、宣传海报等）</td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>自媒体设计用途</td>
                    <td>微博、微信、头条、抖音 等自媒体平台设计用字</td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>办公设计用途</td>
                    <td>PPT、工作汇报、策划案等</td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>VI用途</td>
                    <td>企业VI、宣传册、企业内刊 等设计用途</td>
                    <td class="sq-icons-x">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/>
                            <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"/>
                          </svg>
                    </td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>出版印刷用途</td>
                    <td>图书、漫画、插画、杂志、 报纸等印刷用字</td>
                    <td class="sq-icons-x">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/>
                            <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"/>
                          </svg>
                    </td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>包装设计用途</td>
                    <td>用于市场流通的食品、日用 百货、电器等各类实物产品 的包装设计用字</td>
                    <td class="sq-icons-x">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"/>
                            <path fill-rule="evenodd" d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"/>
                          </svg>
                    </td>
                    <td class="sq-icons">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </td>
                </tr>
            </table>
        </div>

    </div>
</div>